import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { fadeInAnimation } from 'app/core/route-animation/route.animation';
import { AuthService } from 'app/services/auth.service';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { ReportService } from 'app/services/report.service';
import { SpinnerService } from 'app/services/spinner.service';

@Component({
  selector: 'ms-new-report-list',
  templateUrl: './new-report-list.component.html',
  styleUrls: ['./new-report-list.component.css'],
  encapsulation: ViewEncapsulation.None,
  host: {
    "[@fadeInAnimation]": 'true'
  },
  animations: [fadeInAnimation]
})
export class NewReportListComponent implements OnInit, AfterViewInit {

  @ViewChild('hdrTplWithNoSearch') hdrTplWithNoSearch: TemplateRef<any>;
  @ViewChild('hdrTplWithTextSearch') hdrTplWithTextSearch: TemplateRef<any>;
  @ViewChild('hdrTplWithDateSearch') hdrTplWithDateSearch: TemplateRef<any>;
  @ViewChild('hdrTplWithSelectOptionSearch') hdrTplWithSelectOptionSearch: TemplateRef<any>;

  @ViewChild('actionCellTpl') actionCellTpl: TemplateRef<any>;
  @ViewChild('expireDateTpl') expireDateTpl: TemplateRef<any>;
  @ViewChild('createDateTpl') createDateTpl: TemplateRef<any>;
  @ViewChild('statusTpl') statusTpl: TemplateRef<any>;
  @ViewChild('subjectTpl') subjectTpl: TemplateRef<any>;
  @ViewChild('completamentoTpl') completamentoTpl: TemplateRef<any>;

  rows = [];
  columns = [];
  dataRows = [];
  excelRows = [];

  defaultSort = [
    {
      prop: 'dateCreated',
      dir: 'desc'
    }
  ];

  previousSubjectFilter = '';
  previousStatusFilter = '';
  previousCreationDateFilter: Date = null;

  header: string[] = [];

  constructor(
    private router: Router,
    private reportService: ReportService,
    private commonUtilService: CommonUtilService,
    private spinnerService: SpinnerService,
    private auth: AuthService,
    private datePipe: DatePipe) {

    this.spinnerService.start();
    this.reportService.getTableReports(this.auth.isAdmin()).subscribe(data => {
      this.rows = data;
      this.dataRows = data;
      /* console.log(this.rows); */
      this.spinnerService.stop();
    });
  }

  ngAfterViewInit(): void {
    this.columns = [
      { name: 'Nome Richiesta Report', cellTemplate:this.subjectTpl, headerTemplate: this.hdrTplWithTextSearch, width: 200, resizeable: false },
      { name: 'Data creazione', headerTemplate: this.hdrTplWithDateSearch, cellTemplate: this.createDateTpl, comparator: this.columnCreateDateComparator.bind(this), width: 150, resizeable: false },
      { name: 'Stato', prop: 'status', headerTemplate: this.hdrTplWithSelectOptionSearch, cellTemplate: this.statusTpl, maxWidth: 180, resizeable: false },
      { name: 'Numero Report', prop: 'requestNumber', headerTemplate: this.hdrTplWithNoSearch, width: 180, resizeable: false, comparator: this.columnRequestNumberComparator.bind(this) },
      { name: 'Data scadenza', headerTemplate: this.hdrTplWithNoSearch, cellTemplate: this.expireDateTpl, comparator: this.columnExpireDateComparator.bind(this), width: 150, resizeable: false },
      { name: 'Completamento', cellTemplate:this.completamentoTpl ,sortable: true, headerTemplate: this.hdrTplWithNoSearch, maxWidth: 140, resizeable: false },
      { name: 'Dettagli', sortable: false, cellTemplate: this.actionCellTpl, headerTemplate: this.hdrTplWithNoSearch }
    ];
    if (this.auth.isAdmin()) {
      this.columns.splice(1, 0, { name: 'Cliente', prop: 'userId', width: 200, headerTemplate: this.hdrTplWithNoSearch, sortable: true, resizeable: false })
    }
  }

  ngOnInit(): void {
    this.commonUtilService.translateLang("HRWE.PAGE_TITLE.REPORT_LIST");
  }

  goToDetail(requestNumber) {
    this.spinnerService.start();
    this.router.navigate(['/report/detail/view/' + requestNumber]);
  }


  filterByStatus(event) {
    this.spinnerService.start();
    //console.log("filterByStatus "+event.target.value);
    const filter = event.target.value;
    this.previousStatusFilter = filter;
    this.rows = this.filterRows(filter, this.previousSubjectFilter, this.previousCreationDateFilter);
    this.spinnerService.stop();
  }

  filterBySubject(event) {
    this.spinnerService.start();
    //console.log("filterBySubject "+event.target.value);
    const filter = event.target.value;
    this.previousSubjectFilter = filter;
    this.rows = this.filterRows(this.previousStatusFilter, filter, this.previousCreationDateFilter);
    this.spinnerService.stop();
  }

  filterByCreationDate(event) {
    //console.log("filterByCreationDate " + event.target.value);
    this.spinnerService.start();
    if (event.target.value != '') {
      const filter = event.target.value;
      var selectedDate = new Date(filter);
      selectedDate.setHours(0, 0, 0, 0);
      this.previousCreationDateFilter = selectedDate;
      this.rows = this.filterRows(this.previousStatusFilter, this.previousSubjectFilter, selectedDate);
    } else {
      this.rows = this.filterRows(this.previousStatusFilter, this.previousSubjectFilter, null);
    }
    this.spinnerService.stop();
  }

  filterRows(statusFilter, subjectFilter, dateFilter): any[] {
    statusFilter = statusFilter.toLowerCase();
    subjectFilter = subjectFilter.toLowerCase();
    this.rows = this.dataRows;
    return this.rows.filter(row => {
      const isPartialStatusMatch = row.status !== null && row.status.toLowerCase().indexOf(statusFilter) !== -1 || !statusFilter;
      const isPartialSubjectMatch = row.referencePerson.toLowerCase().indexOf(subjectFilter) !== -1 || !subjectFilter;
      const isPartialCreationDateMatch = !dateFilter || new Date(row.dateCreated).toDateString() === dateFilter.toDateString();
      return isPartialStatusMatch && isPartialSubjectMatch && isPartialCreationDateMatch;
    });
    
  }

  columnExpireDateComparator(propA, propB, rowA, rowB) {
    if (rowA.validEndDate < rowB.validEndDate) { return -1; }
    if (rowA.validEndDate > rowB.validEndDate) { return 1; }
  }

  columnCreateDateComparator(propA, propB, rowA, rowB) {
    if (rowA.dateCreated < rowB.dateCreated) { return -1; }
    if (rowA.dateCreated > rowB.dateCreated) { return 1; }
  }

  columnRequestNumberComparator(propA, propB, rowA, rowB) {
    if (Number(rowA.requestNumber) < Number(rowB.requestNumber)) { return -1; }
    if (Number(rowA.requestNumber) > Number(rowB.requestNumber)) { return 1; }
  }

  exportToExcel(): void {

    this.spinnerService.start();

    this.excelRows = this.exportRows();
    
    this.commonUtilService.ExportAsExcel('Reports', this.excelRows, "Storico dei Report - HRWE.xlsx");

    this.spinnerService.stop();

  }

  exportToPDF(): void {
    this.spinnerService.start();

    this.excelRows = this.exportRows();

    this.commonUtilService.ExportAsPDF(true, this.header, this.excelRows, "Storico dei Report - HRWE.pdf");
    
  }

  exportRows() {

    if(this.auth.isAdmin()){
      this.header = ['Nome Richiesta Report', 'Cliente', 'Data creazione', 'Stato', 'Numero Report', 'Data scadenza', 'Completamento'];
      let arr = this.rows.map(rec => {
        return {
          'Nome Richiesta Report' : rec.referencePerson,
          'Cliente' : rec.userId,
          'Data creazione' : this.datePipe.transform(rec.dateCreated, 'dd/MM/yyyy'),
          'Stato' : this.commonUtilService.decodeReportStatus(rec.status),
          'Numero Report' : rec.requestNumber,
          'Data scadenza' : this.datePipe.transform(rec.validEndDate, 'dd/MM/yyyy'),
          'Completamento' : rec.completedCandidates+"/"+rec.noOfCandidates
        }
      });
      return arr;
    } else {
      this.header = ['Nome Richiesta Report', 'Data creazione', 'Stato', 'Numero Report', 'Data scadenza', 'Completamento'];
      let arr = this.rows.map(rec => {
        return {
          'Nome Richiesta Report' : rec.referencePerson,
          'Data creazione' : this.datePipe.transform(rec.dateCreated, 'dd/MM/yyyy'),
          'Stato' : this.commonUtilService.decodeReportStatus(rec.status),
          'Numero Report' : rec.requestNumber,
          'Data scadenza' : this.datePipe.transform(rec.validEndDate, 'dd/MM/yyyy'),
          'Completamento' : rec.completedCandidates+"/"+rec.noOfCandidates
        }
      });
      return arr;
    }

  }

}
